import { ExcludeBaseIcon } from '@tableau/icons/ExcludeBaseIcon';
import { NotificationAlertLowShieldOutlineBaseIcon } from '@tableau/icons/NotificationAlertLowShieldOutlineBaseIcon';
import { NotificationCheckIcon } from '@tableau/icons/NotificationCheckIcon';
import { NotificationInfoOutlineIcon } from '@tableau/icons/NotificationInfoOutlineIcon';
import * as React from 'react';
import { Messages } from '../../gen-src/Localize';
import { ElemAttrs } from '../utils/HtmlAttrs';

export type StatusIconType = 'error' | 'warning' | 'success' | 'info';
export type StatusMessageFieldName = `${StatusIconType}ToastPrefix`;

export const StatusIconColors = {
  Error: '#ba0517',
  Valid: '#22683e',
  Warning: '#6f3400',
  Info: '#05628a',
};

const IconMap: Record<StatusIconType, React.ReactElement> = {
  error: <ExcludeBaseIcon size={14} color={StatusIconColors.Error} />,
  warning: <NotificationAlertLowShieldOutlineBaseIcon size={14} color={StatusIconColors.Warning} />,
  info: <NotificationInfoOutlineIcon size={14} color={StatusIconColors.Info} />,
  success: <NotificationCheckIcon size={14} color={StatusIconColors.Valid} />,
};

function getAltText(type: StatusIconType): string {
  return (Messages as Record<StatusMessageFieldName, () => string>)[`${type}ToastPrefix` as const]();
}

export const StatusIcon: React.FC<{ size?: 14 | 16, type: StatusIconType } & ElemAttrs> = ({ type, ...htmlAttrs }) =>
  React.cloneElement(IconMap[type], {
    'aria-label': getAltText(type),
    key: `${type}_statusIcon`,
    role: undefined,
    ...htmlAttrs,
  });
